/** Fiche d'instructions iOS (Safari n'émet pas beforeinstallprompt). */
export function IosInstallHelp({ onClose }: { onClose: () => void }) {
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Installer Corsalia sur iOS"
      onClick={onClose}
    >
      <div
        className="max-w-sm rounded-2xl border border-sand-500/25 bg-ocean-900/95 p-6 text-ocean-50"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="font-display text-xl text-sand-300">Installer sur iPhone / iPad</h2>
        <ol className="mt-4 space-y-2 text-sm text-ocean-100 list-decimal pl-5">
          <li>Touche le bouton <strong>Partager</strong> en bas de Safari.</li>
          <li>Choisis <strong>Sur l'écran d'accueil</strong>.</li>
          <li>Valide avec <strong>Ajouter</strong>.</li>
        </ol>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full rounded-md border border-ocean-500/40 px-3 py-2 text-sm text-ocean-100 hover:border-sand-300/50 hover:text-sand-200 transition-colors"
        >
          Compris
        </button>
      </div>
    </div>
  )
}
